import React from 'react';
import './App.css';
import LandingPage from './LandingPage/LandingPage';

function App() {
  return (
    <LandingPage />
  );
}

export default App;
